<template>
    <div>
      <div style="padding-top: 20px;padding-bottom: 20px">
        图片文件
      </div>
      <j-image-upload class="avatar-uploader" :disabled="!show" :is-multiple="true" text="上传" @change="uploadChange" v-model="imageList" :bizPath="`${projectId}/${patientId}/formImage/${formId}`" @remove="removeHandle"></j-image-upload>
    </div>
</template>

<script>
  import JImageUpload from '@/components/jeecg/JImageUpload'
  import { postAction,getAction,deleteAction } from '@/api/manage'
  export default {
    name: 'ImageFile',
    components: { JImageUpload, },
    props:{
      show:{
        default:true
      },
      projectId:{
        default:''
      },
      patientId:{
        default:''
      },
      formId:{
        default:''
      },
    },
    data(){
      return {
        imageList:[]
      }
    },
    computed: {
      uploadAction() {
        return `${window._CONFIG['domianURL']}/sys/common/upload`
      }
    },
    watch:{
      formId(){
        this.loadData()
      }
    },
    mounted(){
      this.loadData()
    },
    methods:{
      loadData(){
        getAction('/project/projectFile/listAll',{serveId:this.formId,projectId: this.projectId,type:'6'}).then(res=>{
          if(res.success){
            const fileList = []
            res.result.forEach(item=>{
              if(item.path){
                fileList.push(item.path)
              }
            })
            this.imageList = fileList
          }
        })
      },
      removeHandle(file){
        deleteAction('/project/projectFile/deleteByPath',{path:file.response.message}).then(res=>{
          if(res.success){
            this.loadData()
          }
        })
      },
      uploadChange(pathListStr){
        if(pathListStr){
          const pathList = pathListStr.split(',')
          const path = pathList[pathList.length-1]
          const paths = path.split('/')
          const fileNameInfo = paths[paths.length-1].split('.')
          // console.log(fileNameInfo)
          const formData = {
            serveId:this.formId,
            projectId:this.projectId,
            name:fileNameInfo[0],
            suffix:fileNameInfo[1],
            type:'6',
            path:path,
          }
          postAction('/project/projectFile/add',formData).then(res=>{
            this.loadData()
          }).finally(()=>{
          })
        }

      }
    }
  }
</script>

<style scoped>

</style>